import { render } from "./usersNotifications.vue?vue&type=template&id=5466f9ee"
import script from "./usersNotifications.vue?vue&type=script&lang=js"
export * from "./usersNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__